(function () {
class $779e7aaa51a22e32$var$Header {
    _parentElement;
    _selector = {
        menuOpen: "[data-menu-open]",
        menuClose: "[data-menu-close]",
        menu: "[data-menu]"
    };
    _headerHeight;
    _lastScrollTop = 0;
    /**
   * @param {Element} el
   */ init(el) {
        if (!el) return;
        this._parentElement = el;
        this._addHandlerMenu(this._selector.menuOpen);
        this._initSlimHeader();
    }
    _slimHeader(entries) {
        const [entry] = entries;
        const active = !entry.isIntersecting;
        active ? this._parentElement.setAttribute("data-state", "slim") : this._parentElement.setAttribute("data-state", "");
    }
    _initSlimHeader() {
        this._headerHeight = this._parentElement.getBoundingClientRect().height;
        const header = this._parentElement.closest("#header");
        const headerObserver = new IntersectionObserver(this._slimHeader.bind(this), {
            root: null,
            threshold: 0,
            rootMargin: `${this._headerHeight * 2}px`
        });
        headerObserver.observe(header);
    }
    _toggleMenu() {
        const menu = this._parentElement.querySelector(this._selector.menu);
        const close = this._parentElement.querySelector(this._selector.menuClose);
        if (!menu) return;
        const { state: state } = menu.dataset;
        if (state !== "open") {
            menu.setAttribute("data-state", "open");
            close.focus();
            this._addHandlerMenu(this._selector.menuClose);
        }
        if (state === "open") menu.setAttribute("data-state", "");
    }
    /**
   * @param {String} selector
   */ _addHandlerMenu(selector = this._selector.menuOpen) {
        this._parentElement.addEventListener("click", (function(e) {
            const btn = e.target.closest(selector);
            if (!btn) return;
            this._parentElement = btn.closest('[data-module="header"]');
            this._toggleMenu();
        }).bind(this));
    }
}
var $779e7aaa51a22e32$export$2e2bcd8739ae039 = new $779e7aaa51a22e32$var$Header();


class $f9c75da02b4806d5$var$Accordion {
    _el;
    _trigger;
    _isOpen;
    _panel;
    init($el) {
        this._el = $el;
        this.bindTrigger();
    }
    bindTrigger() {
        this._el.addEventListener("click", (function(e) {
            this._trigger = e.target.closest("[data-accordion-trigger]");
            if (!this._trigger) return;
            this._isOpen = this._trigger.getAttribute("aria-expanded") === "true";
            this.toggle(!this._isOpen);
        }).bind(this));
    }
    toggle(isOpen) {
        this._panel = document.getElementById(this._trigger.getAttribute("aria-controls"));
        if (isOpen === this._isOpen) return;
        this._isOpen = isOpen;
        this._trigger.setAttribute("aria-expanded", `${isOpen}`);
        if (isOpen) this._panel.removeAttribute("hidden");
        else this._panel.setAttribute("hidden", "");
    }
}
var $f9c75da02b4806d5$export$2e2bcd8739ae039 = new $f9c75da02b4806d5$var$Accordion();


class $e28ddeb2a11b3ad7$var$Filter {
    _parentElement;
    _tabs;
    _panels;
    init(el) {
        if (!el) return;
        this._parentElement = el;
        this._tabs = el.querySelectorAll("[data-filter-item] span");
        this._panels = el.querySelectorAll("[data-filter-panel]");
        this._bindFilter();
    }
    _bindFilter() {
        this._parentElement.addEventListener("click", (function(e) {
            const $tab = e.target.closest("[data-filter-item]");
            if ($tab) {
                this._setTabActive($tab);
                this._togglePanel($tab);
            }
        }).bind(this));
    }
    /**
   * @param {Object} $tab
   */ _togglePanel($tab) {
        const target = $tab.dataset.filterItem;
        !target && this._resetPanels();
        target && this._showPanels(target);
    }
    /**
   * @param {Object} $tab
   */ _setTabActive($tab) {
        this._tabs.forEach((e)=>e.dataset.state = "inactive");
        $tab.querySelector("span").dataset.state = "active";
    }
    /**
   * @param {String} target
   */ _showPanels(target) {
        this._panels.forEach((e)=>e.style.display = "none");
        const $panels = this._parentElement.querySelectorAll(`[data-filter-panel*="${target}"]`);
        $panels.forEach((e)=>e.style.display = "block");
    }
    _resetPanels() {
        this._panels.forEach((e)=>e.style.display = "block");
    }
}
var $e28ddeb2a11b3ad7$export$2e2bcd8739ae039 = new $e28ddeb2a11b3ad7$var$Filter();


/**
 * Get all modules from DOM with
 * data-module attribute
 * @param {String} selector
 * @returns {NodesList|Null}
 */ const $7e6258f3559d0f34$var$moduleController = function(selector) {
    if (!selector) return;
    const module = document.querySelectorAll(`[data-module="${selector}"]`);
    return module.length > 0 ? module : null;
};
/**
 * Call init() function of module
 * @param {String} selector
 * @param {Object} module
 */ const $7e6258f3559d0f34$var$moduleInit = function(selector, module) {
    if (!selector || !module) return;
    const item = $7e6258f3559d0f34$var$moduleController(selector);
    if (!item) return;
    item.forEach((el)=>module.init(el));
};
const $7e6258f3559d0f34$var$init = function() {
    $7e6258f3559d0f34$var$moduleInit("header", (0, $779e7aaa51a22e32$export$2e2bcd8739ae039));
    $7e6258f3559d0f34$var$moduleInit("accordion", (0, $f9c75da02b4806d5$export$2e2bcd8739ae039));
    $7e6258f3559d0f34$var$moduleInit("filter", (0, $e28ddeb2a11b3ad7$export$2e2bcd8739ae039));
};
$7e6258f3559d0f34$var$init();

})();
//# sourceMappingURL=app.js.map
